import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const TitleStack = styled(Stack)`
  gap: 8px;
  align-items: center;
  flex-direction: row;
`;

export const ErrorDescriptionStack = styled(Stack)`
  gap: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
